import FeatureGates from '@atlaskit/feature-gate-js-client';

export const serveGithubLinksHydrationWithoutExposure = () => {
	const cohort = FeatureGates.getExperimentValue<string>(
		'enable_github_links_hydration_in_quickfind_recent',
		'cohort',
		'control',
		{ fireExperimentExposure: false },
	);

	return cohort === 'test';
};
